// extracted by mini-css-extract-plugin
export default {"form-fields":"UrFu2"};